export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8">
            有任何问题、建议或合作意向？欢迎通过以下方式联系
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/60 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-3">
                <i className="ri-mail-line text-accent-600 text-lg"></i>
              </div>
              <div className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</div>
              <div className="text-xs text-foreground-500">feedback@91sakura.com</div>
            </div>
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/60 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-3">
                <i className="ri-shake-hands-line text-primary-600 text-lg"></i>
              </div>
              <div className="text-sm font-semibold text-foreground-900 mb-1">商务合作</div>
              <div className="text-xs text-foreground-500">biz@91sakura.com</div>
            </div>
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/60 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-3">
                <i className="ri-bug-line text-accent-600 text-lg"></i>
              </div>
              <div className="text-sm font-semibold text-foreground-900 mb-1">问题报告</div>
              <div className="text-xs text-foreground-500">support@91sakura.com</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}